/* eslint-disable camelcase */
import CancelOrderBlock from 'components/contentBlocks/CancelOrder';
import PropTypes from 'prop-types';
import React from 'react';
import transformLink from 'libs/wordpress/utils/transformLink';
import { wysiwygProp } from 'utils/proptypes/modules/textProps';

const CancelOrderTransformer = ({ content }) => {
    const { confirmation_page, paragraph } = content;

    return <CancelOrderBlock confirmationPage={transformLink(confirmation_page)} text={paragraph} />;
};

CancelOrderTransformer.propTypes = {
    content: PropTypes.shape({
        confirmation_page: PropTypes.object,
        paragraph: wysiwygProp,
    }).isRequired,
};

export default CancelOrderTransformer;
